import httpService from '~/Services/Service';

// W-0730 — Envio de SMS Jurídico. Endpoints do EnvioSmsController (WebAPI).
// httpService.get/post já fazem unwrap para res.data; usar err.message no catch.
// (o interceptor axios já expõe err.message). Permissão negada vem como 400 (SEC-005),
// nunca 403 — o interceptor trata 403/401 como logout.

const BASE = '/imob/juridico/envio-sms';

export const obterMensagem = () => httpService.get(`${BASE}/mensagem`);

export const salvarMensagem = (texto) =>
  httpService.post(`${BASE}/mensagem/salvar`, { texto });

export const excluirMensagem = () => httpService.post(`${BASE}/mensagem/excluir`);

export const listarCobradores = () => httpService.get(`${BASE}/cobradores`);

export const listarDestinatarios = (filtros) =>
  httpService.post(`${BASE}/destinatarios`, filtros);

export const dispararSms = (data) => httpService.post(`${BASE}/disparar`, data);
